import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { Text, IconCheckCircleOutline, Badge } from '@machobear/design-system'
import { useListingData } from '../../../context/listing-data'
import { InsightBlock } from '../insight-block'

const TitleContainer = styled.div`
  height: 21px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`

const PRODUCT_DURATIONS: any = {
  'seven-days-sponsored-listing-package': 7,
  'fourteen-days-sponsored-listing-package': 14,
  'thirty-days-sponsored-listing-package': 28
}

export const UpcomingSponsor = () => {
  const { t } = useTranslation()
  const { currentSponsorship } = useListingData()

  const start = new Date(currentSponsorship?.planned_start_date)
  const startMoment = moment(start).tz(currentSponsorship.user_timezone)

  const duration = PRODUCT_DURATIONS[currentSponsorship.plan_name]

  return (
    <InsightBlock
      testId="boost-listing"
      icon={<IconCheckCircleOutline tone="positive" size="small" />}
    >
      <TitleContainer>
        <Text size="medium" weight="medium">
          {t('Boost your listing')}
        </Text>
        <Badge tone="caution">{t('UPCOMING')}</Badge>
      </TitleContainer>

      <Text>
        {t('l.listing.dashboard.starts_at.text', {
          defaultValue: 'Starts on {{start}} at {{end}} for {{duration}} days.',
          start: startMoment.format('MMM DD'),
          end: startMoment.format('hh:mm A'),
          duration
        })}
      </Text>
    </InsightBlock>
  )
}
